module.exports = __webpack_public_path__ + "static/android-icon-192x192-ef661fbd7150fa7e5608facf11b91306.png";